angular.module('ikeweb.user', [
    'ikeweb.shared.util',
    'ikeweb.shared.validation',
    'ikeweb.shared.notification',
    'ikeweb.shared.promise',
    'ikeweb.shared.caching',
    'ikeweb.shared.hash',
    'ikeweb.shared.filter',
    'ikeweb.shared.input',
    'ikeweb.shared.messaging',
    'ikeweb.shared.dialog',
    'ikeweb.shared.input',
    'ikeweb.shared.logging',
    'ikeweb.shared.repository.parse',
    'ikeweb.subscription',
    'ikeweb.unit',
    'ikeweb.error',
    'ikeweb.event',
    'pascalprecht.translate',
    'ikeweb.routes'
]);


require('./billing');



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/user.module.js
// module id = 413
// module chunks = 0